import React, { useState } from 'react';
import projectsData from '../../content/projectsData';
import Heading from '../../Components/Heading/Heading';
import ProjectCard from '../../Components/ProjectCard/ProjectCard';
import { useParams } from 'react-router-dom';
import './style.scss';

function Portfolio() {
  const { monProject } = useParams();
  const [filtreProject, setFiltreProject] = useState('');

  const projectsFiltres = projectsData.filter((projectData) =>
    projectData.nom.toLowerCase().includes(filtreProject.toLowerCase())
  );

  return (
    <div>
      <Heading firstWord="Mes" secondWord="Projets" />
      <div className='input'>
        <input 
          type="text"
          placeholder="Filtrer par nom de projet"
          value={filtreProject}
          onChange={(e) => setFiltreProject(e.target.value)}
        />
      </div>
      <div className="portfolio">
        {projectsFiltres.length > 0 ? (
          projectsFiltres.map((projectData) => (
            <ProjectCard key={projectData.id} {...projectData} />
          ))
        ) : (
          <p className='aucun'>Aucun projet trouvé</p>
        )}
      </div>
    </div>
  );
}

export default Portfolio;